import React, {useEffect, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import Button from "../../components/button";
import {FaEraser, FaPlusSquare} from "react-icons/fa";
import InputDateTime from "../../components/input-datetime";
import SelectComponent from "../../components/select-component";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import {useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../services/project-service";
import afterSaleService from "../../services/after-sale-service";
import general from "../../utils/general";
import TruncateCellRenderer from "../../components/cell-renderer/truncate-cell-renderer";

const initialFilters = {
    date_init: "",
    date_end: "",
    user_project: "",
    attendance: "",
}
const AfterSale = () => {
    const navigate = useNavigate();
    const [filters, setFilters] = useState(initialFilters);
    const [selectedInitDate, setSelectedInitDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const defaultColDef = useMemo(() => ({ resizable: false }), []);

    const gridRef = useRef();

    const [columnDefs] = useState([
        { field: "date", headerName: "Data", maxWidth: 125,
            cellRenderer: params => {
                return general.formatDate(params.value, "DD/MM/YYYY")
            },
        },
        { field: "project", headerName: "Projeto", flex: 1, minWidth: 250,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return general.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        { field: "attendances", headerName: "Atendente", flex: 1, minWidth: 250,
            cellRenderer: params => {
                return general.prepareArrayToList(params.value);
            },
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return general.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        { field: "requests_count", headerName: "Solicitações",cellClass: "justify-center", maxWidth: 100,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return general.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        { field: "duration", headerName: "Duração", flex: 1,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return general.hourComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        { field: "description", headerName: "Descrição", flex: 1, cellRenderer: TruncateCellRenderer,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return general.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
    ]);
    const handleSelect = (id, value) => setFilters(prev => ({ ...prev, [id]: value }));

    const { data: projects } = useQuery({
        queryFn: () => projectService.options().then(({data}) => data),
        queryKey: ["projects"]
    });

    const { data: saleAttendances, isLoading } =useQuery({
        queryFn: () => afterSaleService.list(filters).then(({data}) => data),
        queryKey: ['trainings', filters]
    });

    const { data: users } = useQuery({
        queryFn: () => afterSaleService.getAttendances().then(({data}) => data),
        queryKey: ['users']
    });

    const onCellClicked = (cell) => {
        navigate(`/after-sales/attendances/form/${cell.data.id}`)
    };

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
        if (selectedEndDate && selectedInitDate) {
            setFilters(prev => ({...prev, date_init: selectedInitDate, date_end: selectedEndDate}));
        } else {
            setFilters(prev => ({...prev, date_init: "", date_end: ""}));
        }
    }, [selectedInitDate, selectedEndDate]);

    const clearFields = () => {
        setFilters(initialFilters)
        setSelectedInitDate(null)
        setSelectedEndDate(null)
    }

    return (
        <TemplateDefault title="Cadastro de Atendimentos" isLoading={isLoading}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-2" onClick={() => navigate("/after-sales/attendances/form")}>
                        <FaPlusSquare /> Novo atendimento
                    </Button>

                    <div className={"col-span-2"}>
                        <InputDateTime id={"date_init"} label={"Data abertura (inicio)"} selected={selectedInitDate}
                                       onChange={date => setSelectedInitDate(date)} />
                    </div>
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date_end"} label={"Data abertura (fim)"} selected={selectedEndDate}
                                       onChange={date => setSelectedEndDate(date)}  />
                    </div>

                    <SelectComponent
                        col="col-span-3"
                        instanceId="user_project"
                        label="Projeto"
                        options={projects ?? []}
                        value={filters.user_project}
                        onChange={(value) => handleSelect("user_project", value)}
                        name="user_project"
                    />


                    <div className="col-span-3">
                        <div className="flex justify-between">
                            <SelectComponent
                                col="w-[calc(100%-60px)]"
                                instanceId="attendance"
                                label="Atendente"
                                options={users ?? []}
                                onChange={(value) => handleSelect("attendance", value)}
                                value={filters.attendance}
                                name="attendance"
                            />
                            <div>
                                <Button onClick={clearFields}>
                                    <FaEraser />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{ height: "calc(100vh - 233px)" }}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={saleAttendances}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[100, 200, 300, 400, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        gridOptions={{ localeText: LocalizationAgGrid }}
                    />
                </div>
            </Card>

        </TemplateDefault>
    );
};

export default AfterSale;
